var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{class:_vm.$style.item,attrs:{"to":_vm.item.url}},[_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }